import { IVisibleViolationsState } from './types';

export const defaultState: IVisibleViolationsState = {
  isValid: true,
  skipHash: null,
  errors: [],
};
